import PageState from "../../../../../pomeloproductions/app/resources/js/util/page-state";
import MicroModal from 'micromodal';

export default class BookIndex {

    /**
     * Gets everything set
     */
    init() {
        let chapterWrapper = document.getElementById('chapters');
        this.chapterWrapper = document.getElementById('chapter-wrapper');

        this.root_url = chapterWrapper.dataset['root_url'];
        this.pageState = new PageState();
        this.chapterData = [];

        const chapterPositionsString = window.localStorage.getItem('chapter_positions');
        this.chapterPositions = JSON.parse(chapterPositionsString ? chapterPositionsString : '{}');

        this.migrate();

        let index = true;
        this.chapterDivs = Array.from(document.getElementsByClassName('chapter'));
        this.chapterDivs.forEach(chapter => {
            let chapterData = chapter.dataset;
            this.chapterData.push(chapterData);

            console.log('chapter', chapter);
            chapter.addEventListener('click', (event) => {
                event.preventDefault();
                this.goToChapter(chapterData);
            });

            if (this.getFullChapterUrl(chapterData) === window.location.pathname) {
                this.initializeWithChapter(chapterData);
                index = false;
            }
        });

        if (index) {
            this.chapterWrapper.className = this.chapterWrapper.className.replace("hidden", "");
        }

        const chapter1Btn = document.getElementById('go-to-chapter-1');
        chapter1Btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.goToChapter(this.chapterData[0]);
            MicroModal.close('modal-book_explanation');
        });

        MicroModal.init({});
    }

    /**
     * Migrates from when there was only one article. This can be deleted shortly,
     */
    migrate() {

        let currentParagraph = window.localStorage.getItem('current_paragraph');
        if (currentParagraph && currentParagraph !== '0') {
            this.chapterPositions['chapter-1'] = currentParagraph - 0;
            this.saveChapterPositions();
            window.localStorage.removeItem('current_paragraph');
        }
    }

    /**
     * Initializes the chapter with the passed in data, and shows any modals if we need to
     * @param chapterData
     */
    initializeWithChapter(chapterData) {
        let savedChapter = window.localStorage.getItem('current_chapter');
        if (!savedChapter && chapterData.chapter_number != 1) {
            MicroModal.show('modal-book_explanation', {
                disableScroll: true,
                debugMode: true,
            });
        }
        let currentParagraph = this.chapterPositions['chapter-' + chapterData['chapter_number']];

        this.goToChapter(chapterData, () => {
            if (currentParagraph && currentParagraph !== '0') {
                let paragraph = this.paragraphs[currentParagraph - 0];

                if (paragraph) {

                    window.scrollTo(0, paragraph.offsetTop - 20);
                }
            }
        });
    }

    /**
     * Gets the full chapter url that we can use
     * @param chapter
     * @return {string}
     */
    getFullChapterUrl(chapter) {

        let url = "/";
        if (this.root_url) {
            url+= this.root_url + "/";
        }
        url+= chapter['url'];

        return url;
    }

    /**
     * Takes us to the passed in chapter
     * @param chapter
     * @param complete
     */
    goToChapter(chapter, complete = () => {}) {

        this.currentChapter = chapter;

        let url = this.getFullChapterUrl(chapter);

        localStorage.setItem('current_chapter', chapter['chapter_number']);

        this.pageState.goToPageUrl(url);
        if (!this.chapterWrapper.classList.contains('hidden')) {
            this.chapterWrapper.className+= ' hidden';
        }
        setTimeout(() => {
            let backButton = document.createElement('button');
            backButton.innerText = "< Index";
            backButton.addEventListener('click', (event) => this.goToIndex(event));

            let header = document.createElement('h2');
            header.innerHTML = chapter['title'];

            let div = document.createElement('div');
            div.className = "to-index";
            div.innerHTML = chapter['content'];
            this.chapterWrapper.innerHTML = "";

            this.chapterWrapper.appendChild(backButton);
            this.chapterWrapper.appendChild(header);
            this.chapterWrapper.appendChild(div);

            this.paragraphs = document.querySelectorAll('p, figure');
            window.addEventListener('scroll', () => this.checkScroll());
            this.chapterWrapper.className = this.chapterWrapper.className.replace("hidden", "");
            complete();
        }, 1000);
    }

    /**
     * Takes us back to the index, so the user can browse their
     * @param event
     */
    goToIndex(event) {
        if (event) {
            event.preventDefault();
        }
        this.chapterWrapper.className+= ' hidden';
        this.pageState.goToPageUrl("/" + this.root_url);

        setTimeout(() => {
            this.chapterWrapper.innerHTML = "";

            this.chapterDivs.forEach(chapter => {
                this.chapterWrapper.appendChild(chapter);
            });

            this.chapterWrapper.className = this.chapterWrapper.className.replace("hidden", "");
        }, 1000);
    }

    /**
     * Sets an event to trigger in a few milli seconds that will record when the scroll stopped
     */
    checkScroll() {

        if (this.scrollStopTimeout) {
            clearTimeout(this.scrollStopTimeout);
        }

        this.scrollStopTimeout = setTimeout(() => this.recordPosition(), 50);
    }

    /**
     * Records the scroll position the user is currently at
     */
    recordPosition() {

        let currentParagraph = 0;
        for (let i = 0; i < this.paragraphs.length; i++) {
            let paragraph = this.paragraphs[i];

            if (paragraph.offsetTop < window.scrollY) {
                currentParagraph = i;
            } else {
                break;
            }
        }
        this.chapterPositions['chapter-' + this.currentChapter['chapter_number']] = currentParagraph;
        this.saveChapterPositions();
    }

    /**
     * Stores the chapter positions of the page
     */
    saveChapterPositions() {
        window.localStorage.setItem('chapter_positions', JSON.stringify(this.chapterPositions));
    }

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
}
